import { lazy } from 'react';

const MainLayout = lazy(() => import("./main-layout"));

export { MainLayout };